import { api } from "@/utils/api";
import { queryOptions, useQuery } from "@tanstack/react-query";

export type MatchedFilters<T = string | number | boolean> = {
  filterName: string;
  values: T[];
}[];

export function useMatchedTargetGroupFilters(leadId?: number) {
  return useQuery(matchedTargetGroupFiltersQuery(leadId));
}

export const matchedTargetGroupFiltersQuery = (leadId?: number) => {
  return queryOptions({
    queryKey: ["matchedTargetGroupFilters", leadId],
    queryFn: async (): Promise<MatchedFilters<string | boolean> | null> => {
      if (!leadId) {
        return null;
      }

      return api
        .get(`apps/sales/leads/${leadId}/matched-filters`)
        .json<MatchedFilters>()
        .then(
          (filters): MatchedFilters<string | boolean> =>
            filters.map((f) => ({
              ...f,
              values: f.values.map((v) =>
                // Code expects string or boolean, so convert numbers to strings
                typeof v === "number" ? v.toString() : v,
              ),
            })),
        );
    },
    enabled: !!leadId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
